import { staticText } from '../../../utils/translations/staticText';

const money101Translation = staticText({
  loan: {
    _: 'Loan',
    zh: '貸款',
  },
  show_all_banking_products: {
    _: 'Show All Products',
    zh: '顯示所有銀行戶口',
  },
  show_all_investment_products: {
    _: 'Show All Products',
    zh: '顯示全部證卷商',
  },
  sta_bka_bank_gift: {
    _: `Provider Gift - On Top of Money101`,
    zh: '銀行優惠',
  },
  offers: {
    _: 'Offers',
    zh: '申辦及達指定門檻即享有以下優惠:',
  },
  brand_reward: {
    _: 'Money101 Reward',
    zh: 'Money101 獨家好禮',
  },
  brand_reward_stk_bka: {
    _: 'Money101 Reward',
    zh: 'Money101 好禮價值',
  },
  hot_reward_pick: {
    _: 'Hot Reward Pick',
    zh: 'Money101 獨家好禮',
  },
  monthly_repayment: {
    _: 'Monthly Repayment',
    zh: '每月還款金額',
  },
  annual_interest_rate: {
    _: 'Annual Interest Rate',
    zh: '年利率',
  },
  eir: {
    _: 'EIR',
    zh: '總費用年百分率',
  },
  MAXIMUM_LOAN_AMOUNT: {
    _: 'Max Loan Amount',
    zh: '最高貸款金額',
  },
  product_stk: {
    _: 'Product Name',
    zh: '證卷商',
  },
  product_bka: {
    _: 'Product Name',
    zh: '銀行帳戶',
  },
});
export default money101Translation;
